import React, { useState, useEffect } from 'react';
import { Multiselect, ButtonField, InputField, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup, ButtonGroupItem } from '@wk/components-react16';
import { API_USER } from '../../../core/constants';
import Api from '../../../core/api';
import { logUserActivity, Toast, UserActivity } from "../../../services"

const AddRole = ({ isAddRoleOpen, setIsAddRoleOpen, role, isEdit, setIsLoad }: any) => {
    const initialRole = isEdit ? role.name : '';
    const [roleName, setRoleName] = useState(initialRole);

    const [privilegeList, setPrivilegeList] = useState([]);

    const handleUserRequest = (origin: string) => {
        if (origin === 'esc' || origin === 'header' || origin === 'footer') {
            setRoleName('');
            setIsAddRoleOpen(false);
        }
    }

    const submit = async () => {
        if (roleName.trim() === '') {
            Toast("Please enter role name", "error")
            return;
        }
        if (privilegeList.filter((item: any) => item.isSelected).length === 0) {
            Toast("Please assign Privileges.", "error")
            return;
        }
        const privileges = privilegeList.filter((item: any) => item.isSelected === true).map((item: any) => item.id);
        let payload: any = {
            name: roleName.trim(),
            privileges: privileges
        };
        if (isEdit) {
            payload['oldName'] = role ? role.name : '';
            payload['id'] = role ? role.id : 0;
        }
        let url = isEdit ? `${API_USER.UPDATE_ROLES}` : `${API_USER.ADD_ROLES}`;

        Api.postRequest(url, payload).then(
            (res: any) => {
                setRoleName('');
                setIsAddRoleOpen(false);
                Toast(isEdit ? "Role Updated successfully." : "Role added successfully.", "sucsess")
                setIsLoad(true)
            },
            (err: any) => {
                Toast(err.message, "error")
            },
        )
        let userActivity: UserActivity = {
            action: 'Save Button Click',
            page: 'Role Management',
            viewName: isEdit ? 'Edit Role' : 'Add Role',
            entityName: payload.name
        }
        logUserActivity(userActivity);
    }

    const getPrivileges = () => {
        Api.getRequest(API_USER.GET_PRIVILEGES).then(
            (res: any) => {
                let list = res.map((item: any) => ({ ...item, label: item.name, isSelected: false }));
                if (isEdit) {
                    list.forEach((item: any) => {
                        item.isSelected = role.privileges.some(
                            (itm: any) => itm.name.toUpperCase() === item.name.toUpperCase()
                        );
                    });
                }
                setPrivilegeList(list)
            },
            (err: any) => {
                Toast(err.message, "error")
            },
        )
    }

    useEffect(() => {
        getPrivileges()
    }, [])

    return (
        <>
            <Modal
                isOpen={isAddRoleOpen}
                srLabelledBy={'modal-id-001'}
                srDescribedBy={'modal-id-002'}
                width={'432px'}
                onUserRequest={handleUserRequest}>
                <ModalHeader
                    titleId={'modal-id-001'}
                    isFullscreenButtonVisible
                    onUserRequest={() => handleUserRequest('header')}>
                    {isEdit ? 'Update' : 'Add'} Role
                </ModalHeader>
                <ModalBody descriptionId="modal-addrole-1">
                    <div className="wk-row">
                        <div className="wk-col-12">
                            <InputField
                                label="Role Name"
                                labelFor="privilege-1"
                                size="small" indicator="required">
                                <input
                                    type="text"
                                    id="privilege-1"
                                    name="privilege"
                                    value={roleName}
                                    onChange={e => setRoleName(e.target.value)}
                                    placeholder="Enter new privilege"
                                    autoComplete="off"
                                />
                            </InputField>
                            <Multiselect
                                items={privilegeList}
                                pillLabel="Privileges assigned"
                                placeholder="Select Privileges"
                                size="small"
                                label="Privileges"
                                indicator="required"></Multiselect>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <ButtonGroup mode="static">
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField size={'small'} mode={'text'}>
                                <button type="button" id="cancel" onClick={() => handleUserRequest('footer')}>
                                    Cancel
                                </button>
                            </ButtonField>
                        </ButtonGroupItem>
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField size={'small'}>
                                <button type="button" id="save" onClick={() => submit()}>
                                    Save
                                </button>
                            </ButtonField>
                        </ButtonGroupItem>
                    </ButtonGroup>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default AddRole;
